module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "plekan-editor-arena"
  }, [_c('div', {
    staticClass: "plekan-editor"
  }, [_c('editor-list', {
    attrs: {
      "cname": "dynamic-editor",
      "list": _vm.editorButtons.stick,
      "custom": _vm.stickyCustomButtons
    }
  }, [_c('li', {
    staticClass: "create-link",
    slot: "link"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linktext),
      expression: "linktext"
    }],
    attrs: {
      "placeholder": "http://www.example.com"
    },
    domProps: {
      "value": (_vm.linktext)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.linktext = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createLink
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])])]), _vm._v(" "), _c('editor-list', {
    attrs: {
      "cname": "stable-editor",
      "list": _vm.editorButtons.stable,
      "custom": _vm.stableCustomButtons
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "plekan-editable-elements-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openEditElement
    }
  }, [_vm._v("Edit")]), _vm._v(" "), _c('editelement', {
    attrs: {
      "element": _vm.editableModalElement,
      "shown": _vm.editableModal
    }
  }), _vm._v(" "), _c('color-modal', {
    attrs: {
      "shown": _vm.showColorModal,
      "close": _vm.toogleColorModal
    }
  }), _vm._v(" "), (_vm.$plekanEvent.onFileUpload) ? _c('file-upload-modal', {
    attrs: {
      "shown": _vm.showFileUploadModal,
      "close": _vm.toggleFileUploadModal
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bdb85d2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/editor.vue
// module id = 119
// module chunks = 0